<template>
    <div class="form-field form-field__input" :class="rootClasses">
        <label class="form-field--title-label"
                v-if="label"
                :for="id"
                v-html="label"/>
        <div class="form-field--input-container" :data-action-count="0">
            <span class="form-field--floating-label"
                    aria-hidden="true"
                    v-if="label && hasFloatingLabel"
                    v-html="label"/>
            <input class="form-field--input"
                    ref="input"
                    v-bind="inputAttrs"
                    v-model="model"
                    @focus="onFocus"
                    @blur="onBlur">
        </div>
        <form-field-messages :messages="messages"/>
    </div>
</template>

<script>
    import FormFieldMessages from 'framework/components/form/form-field-messages/form-field-messages';
    import formFieldAbstractMixin from 'framework/mixins/form/form-field-abstract';


    export default {
        components: {
            FormFieldMessages,
        },
        mixins: [
            formFieldAbstractMixin,
        ],
        props: {
            value: {
                type: [Number, String],
                required: true,
            },
            type: {
                type: String,
                default: 'text',
            },
            autocomplete: {
                type: String,
                default: null,
            },
            pattern: {
                type: String,
                default: null,
            },
        },
        computed: {
            specificRootClasses() {
                return [
                    this.bemIf(this.hasFocus, 'has-focus'),
                ];
            },
            specificInputAttrs() {
                const { autocomplete, pattern, placeholder, type } = this;
                return { autocomplete, pattern, placeholder, type };
            },
        },
    };
</script>
